import { styled } from '../theme';
import SideMenuLink from './SideMenuLink';

const TabsNavigationLink = styled(SideMenuLink)(({ theme }) => ({
    flexShrink: 0,
    fontWeight: theme.typography.fontWeight.roman,
    fontSize: '1.6rem',
    height: '100%',
    display: 'block',
    color: theme.color.disabled,
    cursor: 'pointer',
    outline: 'none',
    ':hover': {
        color: theme.color.green1,
        textDecoration: 'none',
    },
    '&.active': {
        color: theme.color.green1,
        textDecoration: 'none',
        borderBottom: `3px solid ${theme.color.green1}`,
    },
}));

export default TabsNavigationLink;
